import { render, staticRenderFns } from "./PaymentConfirmModal.vue?vue&type=template&id=5151478c&scoped=true&"
import script from "./PaymentConfirmModal.vue?vue&type=script&lang=js&"
export * from "./PaymentConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentConfirmModal.vue?vue&type=style&index=0&id=5151478c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151478c",
  null
  
)

export default component.exports